import type { MonthPickerMonth, PrepackageSearchState } from '../../types';
import { PrepackageSearchOriginOptions } from '../data/PrepackageSearchOriginOptions';

const getFlexibleDateRange = (travelMonths: MonthPickerMonth[] | undefined) => {
    if (!travelMonths?.length) return {};
    const sorted = [...travelMonths].sort((a, b) => a.year - b.year || a.month - b.month);
    const first = sorted[0];
    const last = sorted[sorted.length - 1];
    return {
        departureDate: new Date(first.year, first.month - 1, 1).toISOString(),
        returnDate: new Date(last.year, last.month, 0, 23, 59, 59).toISOString(),
    };
};

export const buildPrepackageTrackingItem = (state: PrepackageSearchState) => {
    const destinationParts = state.destinationId?.split(';');
    const dates =
        state.searchType === 'fixed'
            ? { departureDate: state.departureDate?.toISOString(), returnDate: state.returnDate?.toISOString() }
            : getFlexibleDateRange(state.travelMonths);

    return {
        id: 'finntravel',
        type: 'Travel',
        destination: destinationParts?.[1],
        arrivalCity: destinationParts?.[2],
        departureCountry: 'Norge',
        departureCity: PrepackageSearchOriginOptions.find((opt) => opt.value === state.originAirport)?.label,
        travelType: 'prepackage',
        ...dates,
    };
};
